import { z } from 'zod'

import { SupportedMarketKey } from '@nxt-insurance/constants'

import gender from '@flows/configs/common/components/gender'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import type { StringEnum } from '@flows/insurance/types/schemaTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

type GenderProps = {
  market: SupportedMarketKey
}

const commonOptions: StringEnum = ['m', 'f']
const diverseOption = 'd'

const genderSchemaOptions: Record<SupportedMarketKey, StringEnum> = {
  [SupportedMarketKey.De]: [...commonOptions, diverseOption],
  [SupportedMarketKey.At]: [diverseOption, ...commonOptions],
}

const gender_step = ({ market }: GenderProps) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      gender: z.enum<any, StringEnum>(genderSchemaOptions[market]),
    }),
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_common:steps.gender.title' },
        infoButton: {
          modalConfiguration: [
            {
              type: 'title',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_common:steps.gender.modal.title',
              },
            },
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_common:steps.gender.modal.content',
              },
            },
          ],
        },
      },
      gender(market),
    ],
    subFlow: SubFlow.Common,
  }) as const satisfies AnyStepConfiguration

export default gender_step
